<template>
  <!-- 末端试水装置 -->
  <el-dialog :visible="visible" :showClose="false" :modal="false" lock-scroll>
    <div class="enddevice">
      <img src="../assets/img/zoomOut.png" class="zoomOut" @click="onClose" />
      <img src="../assets/img/4-8-2-1.png" />
      <!-- <div class="switch closed"> -->
      <div
        class="switch"
        :class="{
          closed: isCloseFn,
          open: !isCloseFn,
          'anim-open': !isCloseFn,
        }"
        @click="enddeviceFn"
      >
        <div class="bashou"></div>
      </div>
      <div class="water" v-show="!isCloseFn"></div>
      <audio
        ref="audioPlayer"
        src="../assets//audio/10-4-1末端试水装置打开.mp3"
      ></audio>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    enddeviceFunc: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    length:{
      type:Number,
      default:1
    },
    isClose: {
      type: Boolean,
      default: true,
    },
    close: {
      type: Function,
    },
  },
  watch: {
    isClose: {
      immediate: true,
      handler(val) {
        this.isCloseFn = val;
        
      },
    },
  },
  data() {
    return {
      isCloseFn: true,
    };
  },
  methods: {
    enddeviceFn() {
      if (!this.$parent.auto) return;
      // 关闭状态，能开不能管

     
      if (this.isCloseFn) {
        
          this.isCloseFn = !this.isCloseFn;
          let player = this.$refs.audioPlayer;
          player.play();
          
       
      } else {
        
        // 开启状态， 只能关不能开
        if (!this.isCloseFn) {
          this.isCloseFn = !this.isCloseFn;
          let player = this.$refs.audioPlayer;
          player.pause();
          
          
          
        }
      }
      this.enddeviceFunc && this.enddeviceFunc();

      // if(!this.isCloseFn){ 
      //   this.isCloseFn = true
      // }
    },
    onClose() {
      this.close && this.close();
    },
  },
};
</script>

<style lang="less" scoped>
// 屏幕
.el-dialog__wrapper {
  position: absolute;
}
/deep/.el-dialog {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1.875rem);
  max-width: calc(100% - 1.875rem);
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: auto;
}
/deep/.el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 末端试水装置
.enddevice {
  scale: 0.8;
  background-color: #fff;
  border: 8px solid #fff;
  border-radius: 16px;
  position: relative;
  img {
    border-radius: 16px;
  }
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .switch {
    top: 37.810345%;
    left: 24.5%;
    height: 3.466667%;
    width: 23.892108%;
    position: absolute;
    -webkit-transform-origin: 9rem center;
    transform-origin: 9rem center;
    cursor: pointer;
    .bashou {
      position: absolute;
      left: 0;
      top: 0;
      width: 10.5625rem;
      height: 2rem;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAAZCAMAAAAG5TykAAABqlBMVEUAAADS2uLO1d2jnaWelZx1cXSfm6ObmKCdnKWRLCiemqObmKCssLmcmaGKhI3T1ty9vcaaQT5rEg5cDwuNhY2emaGSho9/eYKdkpp8b3ZuGxaNho1zLSuyo6y3bmtRLi7HqKuWQ0CzusB/QEBxGRR2GhdWFhN1GRSWm55uGROjqKpZGBORlpucnqNrFxOrsLKoqKuWlpt8f4Wjo6hiFxKoq7FuEg1+hIioq6uSlpZuDQmHjZB3fH9YBgBMAgBqDgiws7eeo6mbm55RDgu0t7mOkJCEiI1RFRBRBACxs7OwsLOrq7CFiIh/hIR9fn81NjdNDgqNkZaIiI1/f4Q8PT6VnqNWWFqpSEVxEAu9wMObnp5LTE59GBRaCgaRkZZ/ho2xWVlPUVOuT02pQT1cFxO3ubuEhIhEAwCNjZFvcHOfOTRjDAezs7eVoqlqbW9cYmOgQD1eMjErLC0LCws5BwWcqKuboaiEhIRxdn1kaWuZMzAcHR2go6NjY2NZXGJDQ0PJys6qsLduWVpoT0+DIx49FhV2EQuIkZhwZmpvYWMVFRW+dngtAgCbbnGuUl7RAAAAJHRSTlMADSNkV/3Nq0L9kXYzu4VmHvnx3Znu7uLd3cvCrKui4MyhgHEqc6yWAAAHIElEQVRIx52XZ3/TMBDGw9577xWwo9rxCI7t2JDRJDS72SVp06YlpQNKmWXvPb4zd5Jis17x2JbOsqn+v+fOUggMtW7P2W/fZmZm5uZmZpbas+2ns+2Z9txse2l2dm61PTsHA3NL7bn27NPVpadL9MU5fG3b6szS6tPZpdXV1fbStvfbtr1///7i5MdgdHl5ajn847ryxoDTKBhvFEWRSTqRyyeuD5TBdVBaKVy/PigMEmmIe07V1XWPZ/3pbZMfY7F4LDYRjU3AFf34MT4Ri4Ji8YmJCRjHiD5jgzG4wys4AQ0c8Xg0vDw1NY66BifV+N2mbYuaJmoiSIMzRSwD0BK3Eko+n7uVy90aDG4pINKrOk5W93gmY9FgMHjxIjbQgQRsMBQEGMN76Nk7GLGn7G06jm348o1LvkZGRkbv3u6IsixjgxK1pIpEuURCUQq5fP5WLp9O53KJXELRalkn6zCgPftiYYaBojMIcC8wKAEjFD7gkLyFOy4ahIZEI7wZmbp7WxRlOAFGTskp25aJUSgUBgNDJYalqpZlWFY+nVfyhjRfz047HCiOU+E0fFJsqQQkovagLcwl4PNeZA0zkxGNAAgTRqN3HwKP2JGBCYjEjBZRoaTSrxNJVRkkIHcFEnmu5hRDsex509QlmrJ9MT4/dlwUgyZMQI9CQSEUEqAPhwQhfBkaiIKhUGj4z7yscRa0iBGJHTEFNqUYkU2gjvLXc0RJl7uVSr+k5Imceq7mc4adLWXNT0h0Kh7krgT/4kIhCCKgU+FwUAAQAASgYIjbQxtGhDAcBzX67qEoplJiJ5VCr7SiraqkYymkYPXvNZ6stO41SC4ii3bmuWIX9aw+DUB7haiXLNCQTaANiIEBUhBaIOL+CAiEWcODBTBymYJwKE5E1elg20MiuSoSlXQrJahtRe53iaHaa/2Woc3rpol1tCFOSxZ5fPGcQRHxzwxtYu7ATZgBM3hWTQyIe8RdokS3gUbk0jLFXpKkUkTNv3glKyohpJB8YStWcuFVX5TM8rTZBKJz8eDwDzOLfCa0BXPFShtE0wQ9NP7LDAciRsRhaCkBUVMTh5J6mbVMUl6QImCRm1eRKGLYayJR7EYrkynq5vR00wwcZzj+hQCcCIUD1C6kojEF5InmWH4dMX+GTKNvm4wmhU2muJbpaNlq0up1ewVCiUjSsdWEU+nXakXdNafNx4H9vJ6Hf5zzMVcgDEHE3xDogSGvHD9rePL1iOsaMo2/fUTTxTzKrJUzojRfJYacjRhEZUyybCkrlZZeNMs6JVr2KIIMBDpAoTyIBJni1Y1XEKuJoVKWP1dI9MZfkMCj2wjEN5FaqVwUe/UMYCSfE5ClEgu79AsgKtXLrj497Qb2C9wBn4wt2mF8gMUMGPx7Qzr47kPhX9dGz66hR76A6JGmcZM6Wq3uztuZelWNROQkNQjYoDeUfuVlqVRyXVN3VwIHvK3J/3xoCmBmthLxrQwQBUSFERYN64eD+d/aiE/0uSmJcEgIZdfW3FLVKfWQA4FUS01GVIsU7ErjpT5fhzLCNftk1Ntd/c2BzgyOwIU9nxAMwiGat4uI7GcM9ZtH12g7/uU2ArGsSXb5hSst6Is9C5ieE6SKvH5tWWm30rhTd2qwQiLRxmWKwTUsYiwjgOFULI8o6JAIfAMgJPUFjJf/JBoFIlFiFoE2vVqUsvWVFzKgREgEbEq/zkcSxUql8cSs4Zp9G3+p7fd/ZbClzjeKZslLCq6T6IS3WFJSbP/c+zkUzxomjSpVfrUoOqZ7J6tAKdHc3UpHEoXGM9hRiiXImv4oALoQZzP6hcRDtu9jgrgJ/APEjuJ4KAzLqyNfo5uagKOxUtLkWndFc+brK/0VRSFoE35ncuXr/Xv9TSbWkfswgDoe5c7w+vYI2E4WEvgTnFII0z3NZ/SMogskW7M9j64NiTRJ0sCo6p1Fyally3carWRCMYihpNOlr/efNVp3HhfNkqu74BFo74EJBPKS5afB/ynJRqlpNPadRPlENzgORxr/3EQaWkoYPHarzoJTX2w1Gq0FUcmJ3Wf3n93rtu48KddKtaypJwMcaRl9QPF5aDAk8cY5yL87WEtD6BGCeBrf1KT2SLZUlTJVp1zOFueL9cWX3cq9Z/e/3r8PPJVXfSQqlWvlx4tvhv8PObkcn5ycHO6xrOW7Bx2eFIajPOA15b3Btj6+09Jimro2Oj5+84u9sACuiI5cFR8RIsskCapKuqm/7Da6L1tPFh9/0vVPzUcPiUFOBXxtODN68+rVsatjV65cmYJzauwmxFMQjl29eoWOw2N4BDdjV66Owc3YTeivjEEIAR43b8L5APUdzg+gu3fPB/5b6/ZsljOpTYcPHzp05NixI0ePbkadOLELtIVq+/aDBw9u3719++7du3egNqA2Um2l2olav3c9aB3Vf5H8BKiZpP/uEjBuAAAAAElFTkSuQmCC)
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .switch.closed,
  .switch.open {
    -webkit-transition: -webkit-transform 0.5s linear;
    transition: -webkit-transform 0.5s linear;
    transition: transform 0.5s linear;
    transition: transform 0.5s linear, -webkit-transform 0.5s linear;
  }
  .switch.open {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .switch.anim-open {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .switch.closed {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  .water {
    width: 3.4375rem;
    height: 12.9375rem;
    position: absolute;
    top: 64.090805%;
    left: 41.562038%;
    background: url("../assets/img/water.png") no-repeat;
  }
}
</style>
